<template>
  <span :class="['mbo-icon', {'is-empty': !shown && !label}]" :title="title">
    <img v-if="shown" :src="entry.icon" alt="" @error="broken = true">
    <span v-else-if="label" class="mbo-icon__label">{{ label }}</span>
    <span v-else-if="entry && admin" class="mbo-icon__ph mbo-service">{{ entry.id }}</span>
  </span>
</template>

<script>
import {shortLabel} from '@/common/mlbbBroadcast'

// Иконка заклинания / предмета / эмблемы. Иконки в справочнике пока почти у всех null —
// тогда сокращение названия. Нет в справочнике — в превью админки игровой ID,
// в эфире пустой слот (номера зрителю ни о чём не говорят)
export default {
  name: 'MbOverlayIcon',
  props: {
    entry: {type: Object, default: null},
    admin: {type: Boolean, default: false},
  },
  data() {
    return {broken: false}
  },
  computed: {
    shown() {
      return !!(this.entry && this.entry.icon && !this.broken)
    },
    label() {
      return this.entry && this.entry.known ? shortLabel(this.entry.name) : ''
    },
    title() {
      if (!this.entry) return ''
      return this.entry.description ? `${this.entry.name} — ${this.entry.description}` : this.entry.name
    },
  },
  watch: {
    'entry.icon'() {
      this.broken = false
    },
  },
}
</script>
